/*
 * @Author: Hong.Zhang
 * @Date: 2021-11-03 17:59:45
 * @Description: 
 */

import { Colors } from "./color";

export const TypeFaces = {
  body1: {
    fontSize: 16,
    fontWeight: <const> '400',
    letterSpacing: 0,
    lineHeight: 24,
    color: Colors.black,
  },
  body2: {
    fontSize: 14,
    fontWeight: <const> '400',
    letterSpacing: 0,
    lineHeight: 20,
    color: Colors.black,
  },
  body3: {
    fontSize: 12,
    fontWeight: <const> '400',
    letterSpacing: 0,
    lineHeight: 18,
    color: Colors.black,
  }
}